import React from "react";

const Hero = () => {
  return (
    <div>
      <div className="hero-image"></div>
      <div className="hero-text shadow-lg">
        <p className="text-sky-100 max-sm:text-2xl text-3xl">Hello I'am, </p>
        <p className="text-sky-100 max-sm:text-4xl font-bold text-6xl">
          Web Developer
        </p>
        <div className="mt-10">
          <a
            href="https://www.linkedin.com/in/muhammad-fadillah-abdul-aziz-b4699a238/"
            target="_blank"
            rel="noreferrer"
            className="btn p-3 rounded-md hover:bg-sky-100 hover:text-black bg-sky-500"
          >
            Hire me !
          </a>
        </div>
      </div>
    </div>
  );
};

export default Hero;
